import { render, staticRenderFns } from "./ChecklistType.vue?vue&type=template&id=1b348c5b&scoped=true"
import script from "./ChecklistType.vue?vue&type=script&lang=ts"
export * from "./ChecklistType.vue?vue&type=script&lang=ts"
import style0 from "./ChecklistType.vue?vue&type=style&index=0&id=1b348c5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b348c5b",
  null
  
)

export default component.exports